module.exports = __webpack_public_path__ + "static/img/role.0d642d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/tysdags/role.png
// module id = cRey
// module chunks = 7